<template>
  <div>
    <Header :isactive='4' :ischunrk='true' :isfixed='isFixed' :key="new Date().getTime()"/>
    <div id="banner">
      <!-- {background:'url('+require('@/assets/image/banner-develop.jpg')+') center center no-repeat'} -->
      <img src="@/assets/image/banner-develop.jpg" alt="">
    </div>
    <div id="second-nav" class="fixed-yes">
      <div class="nav-content overflow">
        <a class="nav-item first active left" @click=" goto(542)">职业发展</a>
        <a class="nav-item left" @click=" goto(1135)">优我课堂</a>
        <a class="nav-item left" @click=" goto(1690)">工作环境</a>
        <a class="nav-item left" @click=" goto(3037)">公司福利</a>
        <a class="nav-item left" @click=" goto(3525)">加入我们</a>
      </div>
    </div>
    <div id="company-introduce">
      <div class="introduce-content overflow">
        <div class="content-left left">
          <ul data-v-b2314cc4="" class="left-title-content overflow">
            <li data-v-b2314cc4="" class="li-icon left"></li>
            <li data-v-b2314cc4="" class="li-title left">
              <p data-v-b2314cc4="" class="trans">CAREER DEVELOPMENT</p>
              <p data-v-b2314cc4="" class="title">职业发展</p>
            </li>
          </ul>
          <div class="desc-list">
            <p class="desc-item">我们坚信人才是公司最具价值的资产</p>
            <p class="desc-item">我们认为，员工是公司最宝贵的财富，所以一直高度重视员工的发展</p>
            <p class="desc-item">为员工设计专业和管理的双通道职业发展路径</p>
            <p class="desc-item">让员工的能力得到更清晰的发展</p>
            <p class="desc-item">让每个人的成长贡献能够通过职级体系得到明确的体现</p>
          </div>
        </div>
        <div class="content-right right">
          <div class="bg-develop">
            <img src="@/assets/image/develop-bg.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div id="company-vision" class="overflow">
      <img class="bg-vision" src="@/assets/image/bg-class.jpg" alt="">
      <ul class="vision-content overflow">
        <li class="li-icon left"></li>
        <li class="li-title left">
          <p class="trans">YOUWO CLASSROOM</p>
          <p class="title">优我课堂</p>
        </li>
        <li class="li-desc left">
          <p class="title">员工的专属成长课堂</p>
          <p class="desc">优我课堂（YOUWO Classroom）为每个人设计了个性化的学习与发展道路；</p>
          <p class="desc">希望通过这些努力，与每一个人分享每一个机会的乐趣，迎接每一个机会的挑战；</p>
          <p class="desc">我们选择不同的课程进行培训，打造你在关键领域的专业能力，你的每一次学习都将向你想要的未来更进一步。</p>
          <div style="height: 16px;"></div>
          <p class="desc">> 算法开发，框架开发系列课程</p>
          <p class="desc">> 高效工作技能系列培训 （自我认知、认知世界、保持好新奇心、与人沟通）</p>
          <p class="desc">> 专业技能系列（PLC电气学习，机械设计，光学知识）课程</p>
          <p class="desc">> 通用技能系列课程</p>
          <p class="desc">> 创新力提升系列课程</p>
          <p class="desc">> 领导力系列课程</p>
        </li>
      </ul>
    </div>
    <div id="develop">
      <div class="develop-content overflow">
        <div class="title-content left">
          <p class="trans">WORK ENVIRONMENT</p>
          <p class="title">工作环境</p>
        </div>
        <div class="bg-content right">
          <img class="bg-work" src="@/assets/image/bg-work.jpg" alt="">
        </div>
      </div>
    </div>
    <div id="company-welfare" class="overflow">
      <img class="bg-welfare" src="@/assets/image/bg-welfare.jpg" alt="">
      <ul class="vision-content overflow">
        <li class="li-icon left"></li>
        <li class="li-title left">
          <p class="trans">CORPORATE WELFARE</p>
          <p class="title">公司福利</p>
        </li>
        <li class="li-desc left">
          <p class="desc">> 不断增长的薪资</p>
          <p class="desc">> 五险一金</p>
          <p class="desc">> 健康福利 （年度体检）</p>
          <p class="desc">> 餐费补贴</p>
          <p class="desc">> 股票期权</p>
          <p class="desc">> 带薪年假</p>
          <p class="desc">> 出差补贴</p>
          <p class="desc">> 定期培训</p>
          <p class="desc">> 不定期下午茶</p>
          <p class="desc">> 团建经费</p>
        </li>
      </ul>
    </div>
    <div id="company-join">
      <div class="partner-content">
        <div class="title-content">
          <p class="trans">JOIN US</p>
          <p class="title">加入我们</p>
          <div class="desc-content">
            <p class="desc">我们认为，人的品性是第一位考虑的，同事间的互帮互助我们认为是非常重要的。
              公司主要项目是跨多领域合作的，比如PLC，算法，光学，制程等一系列想和合作完成的，所以对经常居高临下或者遇事推诿，我们原则上是拒绝的。</p>
            <div style="height: 24px;"></div>
            <p class="desc">
              带着兴趣去工作，工作的有成就感，是我们认为可以长久一起共事的重要因素，公司也一直再该方面努力。对此，我们提供项目奖金，包括首次开发奖金，后续的持续销售奖金（不仅仅是业务团队，开发及技术支持部门也有），以及员工学习新技能所需要的各种资料（公司不指定，员工自由选择）报销等。</p>
          </div>
        </div>
        <div class="join-list">
          <a class="join-item" href="" target="_blank">
            <img src="@/assets/image/zhilian-icon.png" alt="">
            智联招聘
          </a>
          <a class="join-item center" href="" target="_blank">
            <img src="@/assets/image/boss-icon.png" alt="">
            BOSS直聘
          </a>
          <a class="join-item join-wechat">
            <img src="@/assets/image/wechat-icon.png" alt="">
            微信公众号
            <div class="wechat">
              <img src="@/assets/image/wechat.png" alt="">
              <div class="wechat-icon"></div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <Footer/>
    <Top/>
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
import Top from '@/components/Top/index.vue'
import $ from 'jquery'

export default {
  components: {'Header': Header, 'Footer': Footer, 'Top': Top},
  data() {
    return {
      navBar: false,
      isFixed: false,
      isScroll: 542,
      hide: -60,
      listenFlag: true
    }
  },
  mounted() {
    const _this = this
    const _href = _this.$route.query.href
    if (_href) {
      _this.isScroll = _href
      window.scrollTo(0, _href)
    } else {
      window.scrollTo(0, 0)
    }
    var _scrollTopInit = document.documentElement.scrollTop || document.body.scrollTop
    _this.handleScroll(_scrollTopInit)
    $(document).ready(function () {
      var p = 0, t = 0;
      $(window).scroll(function () {
        var _scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        var _head = document.getElementsByClassName('header-chunrk-class')[0],
          _nav = document.getElementById('second-nav');
        if (_head) {
          p = $(this).scrollTop();
          if (t < p) {
            //下滚
            var _val2 = 0
            if (_this.hide == -60) {
              var int2 = setInterval(function () {
                _val2 = _val2 - 1
                _this.hide = _val2
                _head.style.top = _val2 + 'px'
                if (_val2 <= -60) {
                  _this.hide = 0
                  clearInterval(int2)
                }
              }, 1)
            }
          } else {
            //上滚
            var _val = -60
            if (_this.hide == 0) {
              var int = setInterval(function () {
                _val = _val + 1
                _this.hide = _val
                _head.style.top = _val + 'px'
                if (_val >= 0) {
                  _this.hide = -60
                  clearInterval(int)
                }
              }, 1)
            }
          }
          if (_scrollTop >= 542) {
            _nav.style.cssText = "position:fixed;top:0px;z-index:99;"
          } else {
            _nav.style.cssText = "position:static;"
          }
          _this.handleScroll(_scrollTop)
          setTimeout(function () {
            t = p;
          }, 0)
        }


      })

    })
  },
  methods: {
    goto(_val) {
      const _this = this
      this.isScroll = _val
      this.listenFlag = false
      window.scrollTo({
        top: _val,
        behavior: "smooth"
      });
      setTimeout(function () {
        _this.handleScroll(_val)
      }, 1000)
    },
    handleScroll(scrollTop) {
      var _list = $('.nav-item')
      if (scrollTop < 1135) {
        _list.removeClass('active')
        _list.eq(0).addClass('active')
      } else if (scrollTop >= 1135 && scrollTop < 1690) {
        _list.removeClass('active')
        _list.eq(1).addClass('active')
      } else if (scrollTop >= 1690 && scrollTop < 2438) {
        _list.removeClass('active')
        _list.eq(2).addClass('active')
      } else if (scrollTop >= 2438 && scrollTop < 3037) {
        _list.removeClass('active')
        _list.eq(3).addClass('active')
      } else if (scrollTop >= 3037 && scrollTop < 3500) {
        _list.removeClass('active')
        _list.eq(4).addClass('active')
      } else if (scrollTop >= 3500 && scrollTop < 4600) {
        _list.removeClass('active')
        _list.eq(5).addClass('active')
      }
    }
  }
}

</script>
<style lang='scss' scoped>
$active: #40A9FF;
$width: 1200px;
$banner-height: 632px;
$font: 14px;
$trans: 0.25;
$opacity: 0.85;
$time-height: 110px;
$animateTime: 0.3s;

.left-title-content {
  .li-icon {
    width: 5px;
    height: 60px;
    background: rgba(64, 169, 255, 1);
  }

  .li-title {
    margin-left: 24px;

    .trans {
      height: 18px;
      font-size: 14px;
      line-height: 18px;
    }

    .title {
      height: 36px;
      font-size: 30px;
      font-weight: 500;
      line-height: 36px;
      margin-top: 8px;
    }
  }
}

.fixed-yes {
  left: 0px;
  top: 0px;
  z-index: 999;
}


#second-nav {
  width: 100%;
  height: 49px;
  background: #ffffff;
  box-shadow: 0px -1px 1px 1px rgba(0, 0, 0, 0.5);

  .nav-content {
    width: $width+30;
    margin: 0 auto;
    text-align: center;

    .nav-item {
      width: 106px;
      margin-left: 118px;
      padding: 14px 0px;
      cursor: pointer;
      text-decoration: none;
      height: 20px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 20px;
    }

    .first {
      margin-left: 0px;
    }

    .active {
      color: $active;
      border-bottom: 1px solid $active;
    }
  }
}

#company-introduce {
  .introduce-content {
    padding: 120px 0px;
    width: $width;
    margin: 0 auto;

    .desc-list {
      margin-top: 60px;

      .desc-item {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 24px;
        margin-top: 24px;
      }
    }

    .bg-develop {
      height: 400px;
      width: 410px;
    }
  }
}

#company-vision,
#company-welfare {
  width: 100%;
  position: relative;

  .bg-vision {
    width: 100%;
    height: 545px;
    min-width: 1920px;
  }

  .bg-welfare {
    width: 100%;
    height: 483px;
    min-width: 1920px;
  }

  .vision-content {
    width: $width;
    margin: 0 auto;
    position: absolute;
    left: 50%;
    top: 0px;
    margin-left: -($width/2);
    color: rgba(255, 255, 255, 0.85);
    padding-top: 120px;

    .li-icon {
      width: 5px;
      height: 60px;
      background: rgba(64, 169, 255, 1);
    }

    .li-title {
      margin-left: 24px;

      .trans {
        height: 18px;
        font-size: 14px;
        line-height: 18px;
      }

      .title {
        margin-top: 8px;
        height: 36px;
        font-size: 30px;
        font-weight: 500;
        line-height: 36px;
      }
    }

    .li-desc {
      margin-left: 230px;

      .title {
        height: 30px;
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        margin-bottom: 16px;
      }

      .desc {
        font-size: 14px;
        line-height: 27px;
      }
    }
  }
}


#develop {
  padding: 120px 0px;
  background: rgba(248, 248, 248, 1);

  .develop-content {
    width: $width;
    margin: 0 auto;
    height: 517px;
    box-shadow: 0px 2px 40px 0px rgba(64, 169, 255, 0.2);
    border-radius: 10px;

    .title-content {
      width: 510px;
      text-align: center;
      margin-top: 210px;
    }

    .bg-content {
      width: 690px;
      height: 517px;
    }
  }

}

#company-desc {
  padding: 120px 0px;

  .company-content {
    .show-list {
      width: $width;
      padding-top: 60px;
      height: 240px;
      margin: 0 auto;

      .item {
        width: 384px;
        height: 240px;
        margin-left: 24px;
        position: relative;

        .bg-img {
          transform: scale(1);
          transition: all, $animateTime;
        }

        .modle {
          position: absolute;
          width: 384px;
          height: 240px;
          background: rgba(0, 0, 0, 0.4);
          left: 0px;
          top: 0px;
          text-align: center;
          transform: scale(1);
          transition: all, $animateTime;

          .title {
            font-size: 24px;
            margin-top: 102px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
        }

        &:hover .modle {
          opacity: 0;
        }

        &:hover .bg-img {
          transform: scale(1.024);
        }
      }

      .first {
        margin-left: 0px;
      }
    }
  }
}

#company-join {
  padding: 120px 0px;

  .partner-content {
    width: $width;
    margin: 0 auto;

    .desc-content {
      margin-top: 55px;
      text-align: left;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 27px;
    }

    .join-list {
      height: 160px;
      width: 488px;
      margin: 0 auto;
      margin-top: 40px;

      .join-item {
        display: inline-block;
        width: 80px;
        height: 80px;
        margin-top: 40px;
        text-decoration: none;
        text-align: center;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 24px;

        img {
          opacity: 0.8;
        }

        &:hover img {
          opacity: 1;
        }
      }

      .center {
        margin-left: 124px;
        margin-right: 124px;
      }

      .join-wechat {
        position: relative;
        cursor: pointer;

        .wechat {
          width: 160px;
          height: 160px;
          position: absolute;
          left: 80px;
          top: -40px;
          display: none;

          .wechat-icon {
            height: 88px;
            width: 88px;
            position: absolute;
            background: #cccccc;
            left: 41px;
            top: 35px;
          }
        }

        /* &:hover .wechat {
          display: block;
        } */
      }
    }
  }
}

#banner {
  width: 100%;

  img {
    width: 100%;
    display: block;
  }
}

.title-content {
  text-align: center;

  .title {
    font-size: 30px;
    height: 36px;
    margin-top: 4px;
    line-height: 36px;
  }

  .icon {
    margin: 10px auto;
    height: 2px;
    width: 24px;
    background: $active;
  }

  .trans {
    font-size: $font;
    opacity: $trans;
  }
}
</style>
